import { Component, Input } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { UiFeedbackService } from '../ui-feedback.service';

@Component({
  selector: 'app-copy-button',
  standalone: true,
  imports: [NgIcon],
  templateUrl: './copy-button.component.html',
})
export class CopyButtonComponent {
  @Input() value = '';
  @Input() ariaLabel = 'Copiar';

  constructor(private feedback: UiFeedbackService) {}

  copy(): void {
    if (this.value == null || this.value === '') {
      return;
    }
    navigator.clipboard?.writeText(String(this.value)).then(
      () => this.feedback.toast('Copiado al portapapeles'),
      () => this.feedback.toast('No se pudo copiar'),
    );
  }
}
